import { DocumentData } from './document-data.model';

export class DocumentViewModel {
    public documents: DocumentData[];
}
